import React, { useEffect, useState, useRef } from 'react';
import { filter, hasIn, map } from 'lodash';
import Flickity from 'react-flickity-component';
import useWindowDimensions from '../hooks/useWindowDimensions';
import HomeBanner from './HomeBanner.jsx';

import './Carousel.scss';

function Carousel({ banners }) {
    const _banners =
        filter(banners, (banner) => hasIn(banner, 'bannerImage.data')) || [];
    const [bannersSet, setBanners] = useState(_banners);
    const [flickityRef, setRef] = useState(undefined);
    const [currentBannerIndex, setCurrentBannerIndex] = useState(0);
    const unmounted = useRef(false);
    const { width: windowWidth } = useWindowDimensions();
    const isMobile = windowWidth < 1024;
    let flkty;

    useEffect(() => {
        if (flkty) {
            if (isMobile) {
                flkty.element.addEventListener('touchmove', () => {
                    flkty.playPlayer();
                });
            } else {
                flkty.element.addEventListener('click', () => {
                    flkty.playPlayer();
                    flkty.pausePlayer();
                });
            }
        }

        return () => {
            unmounted.current = true;
        };
    }, []);

    if (flickityRef) {
        flickityRef.on('change', function (index) {
            setCurrentBannerIndex(index);
        });
    }

    const result = map(bannersSet, (b, idx) => (
        <HomeBanner
            key={idx}
            banner={b}
            idx={idx}
            currentBannerIndex={currentBannerIndex}
        />
    ));

    const flickityOptions = {
        autoPlay: 6000,
        cellAlign: 'center',
        contain: true,
        draggable: isMobile,
        fade: isMobile ? false : true,
        // groupCells: 4,
        pageDots: bannersSet.length > 1,
        prevNextButtons: false,
        wrapAround: true,
        adaptiveHeight: true,
        imagesLoaded: true,
    };

    return bannersSet.length > 1 ? (
        <Flickity
            className='flickity-carousel'
            options={flickityOptions}
            flickityRef={(c) => {
                setRef(c);
                flkty = c;
            }}>
            {result}
        </Flickity>
    ) : (
        <div>{result[0]}</div>
    );
}

export default Carousel;
